<div class="wo-process-state" [ngClass]="getCssClass(state)" [class.wo-process-state--small]="small">
  {{ state | processState }}
  <ng-container *ngIf="extra">
    <span class="wo-order-state__divider"></span>
    <span class="wo-order-state__extra" >{{ extra }}</span>
  </ng-container>
</div>
